/** Classe de autenticação na aplicação */
export class Auth {
    email: string;
    senha: string;
}
